import { addValidator } from 'redux-form-validators'
import { intl } from 'i18n/index'

export const INVALID_PLACE_ID = 'INVALID_PLACE_ID'
export const isInvalidPlace = (place: string) => place === INVALID_PLACE_ID

export const googlePlaceValidator = addValidator({
  defaultMessage: intl.formatMessage({ id: 'form.errors.googlePlace' }),
  validator: function(options, value, allValues) {
    const { pickupWaypoints, receiptWaypoints } = allValues

    if (value === pickupWaypoints[0].address) {
      return !(pickupWaypoints[0]?.googlePlaceId === INVALID_PLACE_ID)
    }

    if (value === receiptWaypoints[0].address) {
      return !(receiptWaypoints[0]?.googlePlaceId === INVALID_PLACE_ID)
    }

    return true
  },
})

export const googlePlaceValidatorRideForm = addValidator({
  defaultMessage: intl.formatMessage({ id: 'form.errors.googlePlace' }),
  validator: function(options, value, allValues) {
    const { start, finish } = allValues

    if (value === start?.address) {
      return start?.googlePlaceId !== INVALID_PLACE_ID
    }

    if (value === finish?.address) {
      return finish?.googlePlaceId !== INVALID_PLACE_ID
    }

    return true
  },
})
